export default __webpack_public_path__ + "static/media/SCHOLARs.70510ece.png";